import { toInputTime } from '../../lib/timeFormat';

export interface OperatingHours {
  [key: string]: {
    open: string;
    close: string;
    closed?: boolean;
  };
}

export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const VENUE_TYPES = ['winery', 'tasting room', 'wine bar', 'restaurant', 'other'] as const;

export type VenueType = (typeof VENUE_TYPES)[number];

export const buildOperatingHours = (
  source?: Record<string, { open?: string; close?: string; closed?: boolean }> | null
): OperatingHours =>
  Object.fromEntries(
    DAYS.map((day) => [
      day,
      {
        open: toInputTime(source?.[day]?.open),
        close: toInputTime(source?.[day]?.close),
        closed: source?.[day]?.closed ?? false,
      },
    ])
  ) as OperatingHours;

export type TabType = 'details' | 'media' | 'media-management' | 'admin';

export const TABS: { id: TabType; label: string; description: string }[] = [
  { id: 'details', label: 'Venue Details', description: 'Basic information, address, and contact details' },
  { id: 'media-management', label: 'Media Management', description: 'Manage logo, hero images, and gallery images' },
  { id: 'media', label: 'Media Library', description: 'Browse and manage all venue media' },
  { id: 'admin', label: 'Admin', description: 'Administrative settings and controls' },
];
